import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Badge } from 'shards-react';
import { TableWrapper, TableHeader, H3, Paragraph } from '@increase/typed-components';

const STATUS_THEME = {
  pending: 'secondary',
  running: 'warning',
  completed: 'success',
  failed: 'danger'
};

const BulkReparseJobSummary = ({ job }) => (
  <TableWrapper className="MarginTop20">
    <TableHeader>
      <H3>
        Tarea {job.id}{' '}
        <Badge pill theme={STATUS_THEME[job.status] || 'secondary'}>
          {job.status}
        </Badge>
      </H3>
    </TableHeader>
    <Row className="p-3">
      <Col>
        <Paragraph>
          Procesados: {job.processedCount} / {job.totalCount ?? '?'} — Éxito: {job.succeededCount} —
          Error: {job.failedCount}
        </Paragraph>
      </Col>
    </Row>
  </TableWrapper>
);

BulkReparseJobSummary.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    totalCount: PropTypes.number,
    processedCount: PropTypes.number,
    succeededCount: PropTypes.number,
    failedCount: PropTypes.number
  }).isRequired
};

export default BulkReparseJobSummary;
